import { useState } from 'react'

import { AppIcons } from '../../../AppIcons'
import { AnimatedTextInputProps } from '../../types'

export const SecureTextEntry = ({
  secureTextEntry,
  success,
  onPress,
}: Pick<AnimatedTextInputProps, 'secureTextEntry' | 'success'> & {
  onPress: (state: boolean) => void
}) => {
  const [passwordIsVisible, setPasswordIsVisible] = useState(false)

  function handleHidePassword() {
    onPress(!passwordIsVisible)
    setPasswordIsVisible((prev) => !prev)
  }

  if (!secureTextEntry) return null

  return (
    <button
      type="button"
      onClick={handleHidePassword}
      className="hover:opacity-70 rounded p-1 transition-opacity"
      style={{
        border: 'none',
        background: 'transparent',
        cursor: 'pointer',
        padding: 4,
      }}
    >
      {!!passwordIsVisible && !success && (
        <AppIcons name="eye" size={28} color="icon.iconTextInput" />
      )}
      {!passwordIsVisible && !success && (
        <AppIcons name="eyeOff" size={28} color="icon.iconTextInput" />
      )}
    </button>
  )
}
